const state = () => ({
        itemId: 0,
        variationId: 0,
        crossseller: [],
        attributes: [],
        variations: []
});

const mutations =
    {
        setQuickViewItemId(state, itemId)
        {
            state.itemId = itemId;
        },

        setQuickViewVariationId(state, variationId)
        {
            state.variationId = variationId;
        },

        setQuickViewCrossseller(state, crossseller)
        {
            state.crossseller = crossseller;
        },

        setQuickViewAttributes(state, attributes)
        {
            state.attributes.push(attributes);
        },

        setQuickViewVariations(state, variations)
        {
            state.variations.push(variations);
        },

    };

const actions =
    {
        setQuickViewItemId({ dispatch, commit, state }, itemId)
        {
            state.itemId = itemId;
        },

        setQuickViewVariationId({ dispatch, commit, state }, variationId)
        {
            state.variationId = variationId;
        },

        setQuickViewCrossseller(state, crossseller)
        {
            state.crossseller = crossseller;
        },

    };

export default
{
    state,
    mutations,
    actions
};
